import * as actionTypes from './actionTypes';

export const submitForm = (payload) => ({ type: actionTypes.SUBMIT, payload });
export const submitFormSuccess = (payload) => ({ type: actionTypes.SUBMIT_SUCCESS, payload });
export const submitFormDataFailure = (payload) => ({ type: actionTypes.SUBMIT_FAILURE, payload });

export const getDraft = (payload) => ({ type: actionTypes.GETDRAFT, payload });
export const getDraftSuccess = (payload) => ({ type: actionTypes.GETDRAFT_SUCCESS, payload });
export const getDraftFailure = (payload) => ({ type: actionTypes.GETDRAFT_FAILURE, payload });

export const confirmForm = (payload) => ({ type: actionTypes.CONFIRM, payload });
export const confirmFormSuccess = (payload) => ({ type: actionTypes.CONFIRM_SUCCESS, payload });
export const confirmFormDataFailure = (payload) => ({ type: actionTypes.CONFIRM_FAILURE, payload });

export const reset = () => ({ type: actionTypes.RESET });
export const submitValidateData = (payload) => ({ type: actionTypes.SUBMIT_VALIDATE, payload });
